export const CHIP_COLORS = ['black-gray', 'blue', 'gray', 'red', 'green', 'purple'];
